import type { PaginationMetadata } from '@mds/shared/types/api';

import Button from './button';

/**
 * Previous/Next for a paginated list.
 *
 * Renders nothing for a single page, so a caller can drop it in unconditionally
 * and a short list stays uncluttered.
 */
export default function Pager({
  pagination,
  onPage,
}: {
  pagination: PaginationMetadata | undefined;
  onPage: (next: number) => void;
}) {
  if (!pagination || pagination.totalPages <= 1) return null;

  return (
    <div className="no-print mt-5 flex flex-wrap items-center justify-between gap-3">
      <span className="font-mono text-md text-ink-muted">
        Page {pagination.page} of {pagination.totalPages}
      </span>
      <div className="flex gap-2">
        <Button
          variant="quiet"
          disabled={pagination.page <= 1}
          onClick={() => onPage(pagination.page - 1)}
        >
          Previous
        </Button>
        <Button variant="quiet" disabled={!pagination.hasMore} onClick={() => onPage(pagination.page + 1)}>
          Next
        </Button>
      </div>
    </div>
  );
}
